import React, { useState } from "react";

export const DialogContext = React.createContext();

export const DialogProvider = ({ children }) => {
  const [state, setState] = useState({
    show: false,
    component: null,
  });

  return (
    <DialogContext.Provider value={{ state, setState }}>
      {children}
    </DialogContext.Provider>
  );
};
